<p-table [value]="config.rows" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
    (onPage)="loadData($event)" [first]="first" [rowsPerPageOptions]="rowsPerPageOptions"
    styleClass="basin-table-height data-grid-component" [showCurrentPageReport]="true" [scrollable]="true"
    currentPageReportTemplate="{first} - {last} of {totalRecords}" sortMode="multiple">
    <ng-template pTemplate="header">
        <tr>           
            <th scope="col" *ngFor="let column of config.columns" [pSortableColumn]="column.field">
                <span class="table-column-header basin-display-flex basin-align-items-center">
                    {{ column.header }} <p-sortIcon [field]="column.header"></p-sortIcon>
                </span>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
        <tr>
            @for (key of getAllKeys([row]); track key) {
            <td><span>{{ row[key] }}</span></td>
            }

            <td *ngIf="config.actionButtonsField">
                <div class="basin-display-flex basin-justify-content-end">
                    <p-inputSwitch [(ngModel)]="checked" ariaLabel="License Status" />
                    @for(action of config.actionButtonsField; track action.label) {
                    <button class="p-button-text basin-ml-3" (click)="action.callback(action.label, row)" pButton>
                        <span class="{{action.iconName}} basin-mr-05"></span>
                        <span class="p-button-label">{{action.label}}</span>
                    </button>
                    }
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>